// @flow
import { APICore } from './apiCore';

const api = new APICore();

// account
// function ApiGetAllKategoriFasilitas(params: any): any {
//     const baseUrl = '/api/admin/kategorimenu';
//     return api.get(`${baseUrl}`, params);
// }
function ApiGetAllHarga(params: any): any {
    const baseUrl = '/api/admin/hargaroom';
    return api.get(`${baseUrl}`, params);
}
// function ApiPostCategoryRoom(params: any): any {
//     const baseUrl = '/api/admin/kategoriroom';
//     return api.create(`${baseUrl}`, params);
// }
function ApiPostHarga(params: any): any {
    const baseUrl = '/api/admin/hargaroom';
    // console.log('🚀 ~ ApiPostFasilitas ~ params:', params);
    return api.create(`${baseUrl}`, params);
}
// function ApiEditKategoriRoom(params: any, id: any): any {
//     const baseUrl = '/api/admin/kategoriroom/' + id;
//     return api.update(`${baseUrl}`, params);
// }
function ApiEditHarga(params: any, id: any): any {
    const baseUrl = '/api/admin/hargaroom/' + id;
    return api.update(`${baseUrl}`, params);
}
// function ApiDeleteKategoriRoom(params: any, id: any): any {
//     const baseUrl = '/api/admin/kategoriroom/' + id;
//     return api.delete(`${baseUrl}`, params);
// }

export {
    // ApiGetAllKategoriMenu,
    ApiGetAllHarga,
    // ApiPostCategoryRoom,
    ApiPostHarga,
    // ApiEditKategoriRoom,
    ApiEditHarga,
    // ApiDeleteKategoriRoom,
};
